import React from 'react'

const FileIcon = () => {
  return (
    <svg
      width="11"
      height="15"
      viewBox="0 0 11 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.99854 0.5C2.89397 0.5 1.99854 1.39543 1.99854 2.5V10.5C1.99854 11.6046 2.89397 12.5 3.99854 12.5L9 12.5C10.1046 12.5 11 11.6046 11 10.5V5H10.9985V3.91421C10.9985 3.51639 10.8405 3.13486 10.5592 2.85355L8.64498 0.93934C8.36368 0.658035 7.98215 0.5 7.58432 0.5H3.99854ZM9 11.5L3.99854 11.5C3.44625 11.5 2.99854 11.0523 2.99854 10.5V2.5C2.99854 1.94772 3.44625 1.5 3.99854 1.5H6.99854V3C6.99854 3.82843 7.67011 4.5 8.49854 4.5H9.99854V5.56135L10 5.56102V10.5C10 11.0523 9.55228 11.5 9 11.5ZM9.79143 3.5H8.49854C8.22239 3.5 7.99854 3.27614 7.99854 3V1.70711L9.79143 3.5ZM0 3.5C0 2.94772 0.447715 2.5 1 2.5V10.5C1 12.1569 2.34315 13.5 4 13.5L9 13.5C9 14.0523 8.55228 14.5 8 14.5H3.78947C1.6966 14.5 0 12.8034 0 10.7105V3.5Z"
        fill="#4D4D4D"
      />
    </svg>
  )
}

export default FileIcon
